import "./sentryInit";

import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import { setWasmUrl } from "@lottiefiles/dotlottie-react";
import wasmUrl from "@lottiefiles/dotlottie-web/dotlottie-player.wasm?url";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/fira-code/400.css";
import "./i18next/config";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

setWasmUrl(wasmUrl);

const root = createRoot(document.getElementById("root") as Element);

root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);

serviceWorker.unregister();
